import { useField } from 'formik';
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';

export default function RadioButtonsGroup(props) {
  const { label, data, rowLabel, ...rest } = props;
  const [field, meta, helpers] = useField(props);

  const isError = meta.touched && Boolean(meta.error);

  const fieldId = field.name;
  const labelId = `${fieldId}-legend`;
  const helperId = `${fieldId}-helper-text`;

  const transformedValue =
    field.value === true
      ? 'Yes'
      : field.value === false
        ? 'No'
        : field.value || '';

  const handleChange = (event) => {
    const newValue =
      event.target.value === 'Yes'
        ? true
        : event.target.value === 'No'
          ? false
          : event.target.value;

    helpers.setValue(newValue);
  };

  return (
    <FormControl
      component="fieldset"
      {...rest}
      error={isError}
      aria-describedby={isError ? helperId : undefined}
      aria-label={label || rowLabel}
    >
      <FormLabel
        component="legend"
        id={labelId}
        sx={label ? {} : visuallyHidden}
      >
        {label || rowLabel || field.name}
      </FormLabel>
      <RadioGroup
        row
        name={field.name}
        value={transformedValue}
        onChange={handleChange}
      // aria-labelledby={label ? labelId : undefined}
      >
        {data.map((item, index) => {
          const accessibleName = rowLabel
            ? `${rowLabel} ${item.value}`
            : (item.label || item.value);
          if (!item.label) {
            return (
              <Radio
                key={index}
                value={item.value}
                inputProps={{ 'aria-label': accessibleName }}
              />
            );
          }

          return (
            <FormControlLabel
              key={item.label + index}
              value={item.value}
              control={
                <Radio inputProps={{ 'aria-label': accessibleName }} />
              }
              label={item.label}
            />
          );
        })}
      </RadioGroup>

      {isError && (
        <FormHelperText id={helperId}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
}
